<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col orange">
            <h3><i class="fas fa-cog"></i>Settings</h3>
          </div>
          <div class="text-right">
            <!-- <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a> -->
          </div>
      </div>
    </div>
    <div class="card-body bid-detail settingWid">
      <div class="mb-4">
        <span class="mr-3">Settlement Calculated</span>
        <span v-if="calculatedDate" class="calcDate"><i class="far fa-calendar-alt"></i> {{moment(calculatedDate).format("MM/DD/yyyy")}}</span>
      </div>
      <div v-if="isAdmin || isEditor" class="d-flex r40">
        <span>Override Settlement</span>
        <datepicker 
          v-model="settilementDate"
          placeholder="mm/dd/yyyy" 
          typeable 
          name="callDate" 
          format="MM/dd/yyyy" 
          :clear-button="false" 
          :calendar-button="false" 
          :disabledDates="disabledDates"
          calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>

        <div class="input-group-append">
          <button @click="setSettings()" type="button">
            <i v-if="!loading" class="fas fa-check"></i>
            <i v-if="loading" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import authService from "@/authService";
import config from "@/config";
export default {
  name: "settingsWidget",
  components: {
     Datepicker
  },
  data() {
    return {
      settings : {},
      loading : true,
      disabledDates: {
        to: this.getYestedayDate()
      },
      isAdmin: false,
      isTrader : false,
      isEditor : false,
      calculatedDate : null,
      settilementDate :null

    };
  },
  methods: {
    getYestedayDate(){
      var currentDate = new Date();
      var yesterdayDate = currentDate.setDate(currentDate.getDate()- 1);
      return new Date(yesterdayDate);
    },
    navigateListPage(){
       window.location.href = "/ims/ims-settings";
    },
    getSettings(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/organization/bid-settings?type=OFFER",
            auth
        )
        .then(result => {
          this.settings = result.data;
          this.calculatedDate = this.settings.previousSettlementDate  ? this.settings.previousSettlementDate :  this.settings.settlementDate;
          this.settilementDate = this.settings.settlementDate;
         // console.log("date",this.calculatedDate)
          this.loading = false;

        })        
    },
    setSettings(){
        this.loading = true;
        let data = {...this.settings};
        delete data.settlementDate;
        data.overrideSettlementDate = this.settilementDate ? this.moment(this.settilementDate).format("MM/DD/YYYY")  : "" ;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        console.log(data)
        this.$http
        .put(
           config.baseUrlBidSide +
            "/organization/bid-settings",
            data,
            auth
        )
        .then(() => {
            this.$alert("Settlement date updated","","success");
            //this.calculatedDate = result.data.settlementDate;
            this.loading = false;

        })     

    }
  },
    mounted() {
     this.getSettings();
     this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;

        }
        //console.log("isa",this.isAdmin);
      });
    }
};
</script>
